import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi';
import State from '@/classes/state';
import { DealerDetails } from '@/models/dealer-details.model';
import Dealer from '@/models/dealer.model';
import Place from '@/models/place.model';
import { Map } from 'leaflet';

const mutations = {
    /**
     * Selects the given filter
     * @param state The Vuex state 
     * @param filterGroupFilterCombi - The filterGroup-filter combination
     */
    SELECT_FILTER(state: State, filterGroupFilterCombi: FilterGroupFilterCombi): void {
        const index = state.selectedFilters.findIndex(selectedFilter => selectedFilter.filter.id === filterGroupFilterCombi.filter.id);

        if (index !== -1) {
            return;
        }

        state.selectedFilters.push(filterGroupFilterCombi);
    },
    /**
     * Unselects the given filter
     * @param state The Vuex state 
     * @param filterGroupFilterCombi - The filterGroup-filter combination
     */
    UNSELECT_FILTER(state: State, filterGroupFilterCombi: FilterGroupFilterCombi): void {
        const index = state.selectedFilters.findIndex(selectedFilter => selectedFilter.filter.id === filterGroupFilterCombi.filter.id);
    
        if (index === -1) {
            return;
        }

        state.selectedFilters.splice(index, 1);
    },
    /**
     * Sets the given searchterm
     * @param store The Vuex state
     * @param searchTerm - The searchterm
     */
    SET_SEARCH_TERM(state: State, searchTerm: string): void {
        state.searchTerm = searchTerm;
    },
    /**
     * Sets the given dealers
     * @param state The Vuex state
     * @param dealers Array of dealers
     */
    SET_DEALERS(state: State, dealers: Array<Dealer>): void {
       state.dealers = dealers;
    },
    /**
     * Sets the map zoom
     * @param state The Vuex state
     * @param zoom The map zoom level
     */
    SET_MAP_ZOOM(state: State, zoom: number): void {
        state.mapZoom = zoom;
    },
    /**
     * Sets the map center
     * @param state The Vuex state
     * @param centerAndZoom The map center and optional zoom
     */
    SET_MAP_CENTER(state: State, center: [number, number]): void {
        state.mapCenter = center;
    },
    /**
     * Sets the map object
     * @param state The Vuex state
     * @param map The map object
     */
    SET_MAP(state: State, map: Map): void {
        state.map = map;
    },
    /**
     * Sets the stateUrl to the given URL
     * @param state The Vuex state
     * @param stateUrl The state URL
     */
    SET_STATE_URL(state: State, stateUrl: string): void {
        state.stateUrl = stateUrl;
    },
    /**
     * Sets the showMap state
     * @param state The Vuex state
     * @param showMap Boolean state
     */
    SET_SHOW_MAP(state: State, showMap: boolean): void {
        state.showMap = showMap;
    },
    /**
     * Sets the mapInitialized state
     * @param state The Vuex state
     * @param mapInitialized Boolean state
     */
     SET_MAP_INITIALIZED(state: State, mapInitialized: boolean): void {
        state.mapInitialized = mapInitialized;
    },
    /**
     * Sets the users place
     * @param state The Vuex state
     * @param myPlace The place
     */
    SET_MY_PLACE(state: State, myPlace: Place): void {
        state.myPlace = myPlace;
    },
    /**
     * Sets the active marker id
     * @param state The Vuex state
     * @param activeMarkerId The marker id
     */
    SET_ACTIVE_MARKER_ID(state: State, activeMarkerId: string | null): void {
        state.activeMarkerId = activeMarkerId;
    },
    /**
     * Sets the active dealer details
     * @param state The Vuex state
     * @param activeDealerId The dealer details
     */
     SET_ACTIVE_DEALER_DETAILS(state: State, activeDealerDetails: DealerDetails | null): void {
        state.activeDealerDetails = activeDealerDetails;
    },
    /**
     * Sets the dealerListOpen state
     * @param state The Vuex state
     * @param dealerListOpen Boolean state
     */
     SET_DEALER_LIST_OPEN(state: State, dealerListOpen: boolean): void {
        state.dealerListOpen = dealerListOpen;
    },
};

export default mutations;
